import {Column, DataTable} from '@hconnect/uikit/src/lib2'
import {Typography} from '@mui/material'
import {useMemo} from 'react'
import {useTranslation} from 'react-i18next'

import {DOWNTIME_ANALYTICS_WIDGET_NAMESPACE} from '../consts'
import {type RcfaStatusTableItem} from '../types'

type RcfaTableProps = {
  data?: RcfaStatusTableItem[]
}

export const RcfaStatusTable = ({data}: RcfaTableProps) => {
  const {t} = useTranslation(DOWNTIME_ANALYTICS_WIDGET_NAMESPACE)

  const columns: Column<RcfaStatusTableItem>[] = useMemo(
    () => [
      {
        key: 'column',
        label: t('rcfaStatusTable.label.column'),
        customTemplate: ({column}) => <Typography variant="h5">{column}</Typography>
      },
      {
        key: 'absoluteNumber',
        label: t('rcfaStatusTable.label.absoluteNumber'),
        customTemplate: ({absoluteNumber}) => <Typography variant="h5">{absoluteNumber}</Typography>
      }
    ],
    [t]
  )

  return (
    <DataTable<RcfaStatusTableItem>
      data={data}
      columns={columns}
      keyExtractor={(item) => item.rowKey}
    />
  )
}
